class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();

    this.addEventListener('click', (e) => {
      const prev = e.target.closest('.cart-drawer-complete__nav-btn--prev');
      const next = e.target.closest('.cart-drawer-complete__nav-btn--next');
      const track = this.querySelector('[data-cart-drawer-complete-track]');
      if (!track || (!prev && !next)) return;
      e.preventDefault();
      const delta = prev ? -track.clientWidth : track.clientWidth;
      track.scrollBy({ left: delta, behavior: 'smooth' });
      window.requestAnimationFrame(() => this.updateCompleteLookNav(track));
    });

    this.addEventListener(
      'scroll',
      (e) => {
        const t = e.target;
        if (t && t.matches && t.matches('[data-cart-drawer-complete-track]')) {
          this.updateCompleteLookNav(t);
        }
      },
      true
    );

    this.addEventListener('cart-drawer-complete-look-updated', () => {
      const track = this.querySelector('[data-cart-drawer-complete-track]');
      if (track) this.updateCompleteLookNav(track);
    });
  }

  updateCompleteLookNav(track) {
    const section = track.closest('[data-cart-drawer-complete-look]');
    if (!section) return;
    const prev = section.querySelector('.cart-drawer-complete__nav-btn--prev');
    const next = section.querySelector('.cart-drawer-complete__nav-btn--next');
    if (!prev || !next) return;
    const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth - 1);
    prev.disabled = track.scrollLeft <= 1;
    next.disabled = track.scrollLeft >= maxScroll;
  }

  setHeaderCartIconAccessibility() {
    bindCartDrawerHeaderTrigger();
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.setAttribute('data-cart-drawer-trigger', '');
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    if (typeof purgeOrphanChainUpgrades === 'function') {
      purgeOrphanChainUpgrades();
    }
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    const completeTrack = this.querySelector('[data-cart-drawer-complete-track]');
    if (completeTrack) this.updateCompleteLookNav(completeTrack);

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    this.scrollPosition = window.scrollY || window.pageYOffset || 0;
    document.body.style.top = `-${this.scrollPosition}px`;
    document.body.classList.add('overflow-hidden-drawer');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden-drawer');
    const previousScroll = Math.abs(parseInt(document.body.style.top || '0', 10)) || 0;
    document.body.style.top = '';
    window.scrollTo(0, previousScroll);
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    // cartDrawerNote.addEventListener('click', (event) => {
    //   event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    // });
    cartDrawerNote.addEventListener('click', (event) => {
      const detailsElement = event.currentTarget.closest('details');

      if (detailsElement) {
        const isOpen = detailsElement.hasAttribute('open');
        event.currentTarget.setAttribute('aria-expanded', !isOpen);
      }
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', CartDrawer);
}

/** Header bag → our cart drawer only (never navigate to /cart page). Bound at load so it works even if constructor races. */
function bindCartDrawerHeaderTrigger() {
  if (window.__swafCartDrawerTriggerBound) return;
  window.__swafCartDrawerTriggerBound = true;

  document.addEventListener(
    'click',
    function (event) {
      if (event.target.closest && event.target.closest('#CartDrawer-Checkout, button[name="checkout"]')) {
        return;
      }
      const cartLink =
        event.target.closest && event.target.closest('#cart-icon-bubble, a.header__icon--cart, [data-cart-drawer-trigger]');
      if (!cartLink) return;
      const drawer = document.querySelector('cart-drawer');
      if (!drawer || typeof drawer.open !== 'function') return;
      event.preventDefault();
      event.stopPropagation();
      drawer.open(cartLink);
    },
    true
  );

  document.addEventListener('keydown', function (event) {
    const cartLink =
      event.target.closest && event.target.closest('#cart-icon-bubble, a.header__icon--cart, [data-cart-drawer-trigger]');
    if (!cartLink) return;
    if (event.code.toUpperCase() !== 'SPACE' && event.code.toUpperCase() !== 'ENTER') return;
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.open !== 'function') return;
    event.preventDefault();
    drawer.open(cartLink);
  });
}

bindCartDrawerHeaderTrigger();

function openCartDrawerFromFlag() {
  try {
    if (sessionStorage.getItem('openCartDrawer') !== '1') return;
  } catch (e) {
    return;
  }
  var attempts = 0;
  function tryOpen() {
    var drawer = document.querySelector('cart-drawer');
    var trigger = document.querySelector('#cart-icon-bubble');
    if (drawer && typeof drawer.open === 'function') {
      try {
        sessionStorage.removeItem('openCartDrawer');
      } catch (e) {}
      drawer.open(trigger || drawer);
      return;
    }
    attempts += 1;
    if (attempts < 40) requestAnimationFrame(tryOpen);
  }
  tryOpen();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', openCartDrawerFromFlag);
} else {
  openCartDrawerFromFlag();
}

/** Chain upgrade add-on lines (priced separately, hidden in drawer UI). */
function isChainUpgradeCartItem(item) {
  if (!item) return false;
  const props = item.properties || {};
  if (props._chain_upgrade) return true;
  const handle = String(item.handle || '').toLowerCase();
  return handle === 'chain-size-upgrade' || handle === 'chain-type-upgrade';
}

function getVisibleCartQuantity(cart) {
  if (!cart || !cart.items) return 0;
  return cart.items.reduce((sum, item) => {
    if (isChainUpgradeCartItem(item)) return sum;
    return sum + (Number(item.quantity) || 0);
  }, 0);
}

function applyCartDrawerSectionState(state) {
  const drawer = document.querySelector('cart-drawer');
  if (!drawer || !state || !state.sections || !state.sections['cart-drawer']) return;
  const html = new DOMParser().parseFromString(state.sections['cart-drawer'], 'text/html');
  const newInner = html.querySelector('.drawer__inner');
  const curInner = drawer.querySelector('.drawer__inner');
  if (newInner && curInner) curInner.replaceWith(newInner);
  const bubble = document.getElementById('cart-icon-bubble');
  if (bubble && state.sections['cart-icon-bubble']) {
    bubble.innerHTML = drawer.getSectionInnerHTML(state.sections['cart-icon-bubble']);
  }
  drawer.classList.toggle('is-empty', !(Number(state.item_count) > 0));
  const overlay = drawer.querySelector('#CartDrawer-Overlay');
  if (overlay) overlay.addEventListener('click', drawer.close.bind(drawer));
}

/** Buy-2+ automatic cart discount (Shopify code must exist & allow combining rules as needed). */
var CART_STACK_DISCOUNT_CODE = 'STACK15';

/** Welcome / first-order codes that must NOT stack with STACK15 */
var CART_WELCOME_DISCOUNT_PATTERN = /welcome|welcom10|welcome10|first10|new10|subscriber10/i;

function normalizeDiscountCode(code) {
  return String(code || '')
    .trim()
    .toUpperCase();
}

function isStackDiscountCode(code) {
  return normalizeDiscountCode(code) === normalizeDiscountCode(CART_STACK_DISCOUNT_CODE);
}

function isWelcomeDiscountCode(code) {
  return CART_WELCOME_DISCOUNT_PATTERN.test(String(code || ''));
}

/**
 * Desired discount string for Cart API `discount` field, or null if no change.
 * - 2+ visible items → STACK15 alone (drops welcome / other codes)
 * - <2 items → remove STACK15; keep non-stack codes if any
 */
function resolveCartDiscountPayload(cart, visibleQty) {
  const codes = Array.isArray(cart.discount_codes) ? cart.discount_codes : [];
  const stackEntry = codes.find((d) => d && isStackDiscountCode(d.code));
  const otherApplicable = codes.filter(
    (d) => d && d.applicable && d.code && !isStackDiscountCode(d.code)
  );
  const welcomeApplicable = otherApplicable.filter((d) => isWelcomeDiscountCode(d.code));

  if (visibleQty >= 2) {
    /* Auto-apply STACK15; never leave welcome stacked on top of it */
    if (!stackEntry) {
      return CART_STACK_DISCOUNT_CODE;
    }
    if (stackEntry.applicable && (welcomeApplicable.length > 0 || otherApplicable.length > 0)) {
      return CART_STACK_DISCOUNT_CODE;
    }
    if (stackEntry.applicable) {
      return null;
    }
    /* Code present but not applicable — do not retry forever (admin/min-qty mismatch) */
    return null;
  }

  /* Under 2 items: STACK15 must not stick; welcome OK alone */
  if (stackEntry) {
    const keep = codes
      .filter((d) => d && d.code && !isStackDiscountCode(d.code))
      .map((d) => String(d.code).trim())
      .filter(Boolean);
    return keep.length ? keep.join(',') : '';
  }

  return null;
}

/**
 * - Remove orphan chain upgrade lines (parent product gone)
 * - Auto-apply STACK15 at 2+ visible items; clear it under 2
 * - When STACK15 is on, strip welcome/%10 codes so they do not stack
 */
function syncCartDrawerSideEffects() {
  const cartUrl = (window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js';
  const updateUrl = window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update.js';

  return fetch(cartUrl)
    .then((r) => r.json())
    .then((cart) => {
      if (!cart || !cart.items) return null;

      const parentGroups = new Set();
      let hasVisible = false;
      cart.items.forEach((item) => {
        if (isChainUpgradeCartItem(item)) return;
        hasVisible = true;
        const group = item.properties && item.properties._chain_group;
        if (group) parentGroups.add(String(group));
      });

      const updates = {};
      cart.items.forEach((item) => {
        if (!isChainUpgradeCartItem(item)) return;
        const group = item.properties && item.properties._chain_group;
        if (!hasVisible || !group || !parentGroups.has(String(group))) {
          updates[item.key] = 0;
        }
      });

      const visibleQty = getVisibleCartQuantity(cart);
      const discountValue = resolveCartDiscountPayload(cart, visibleQty);

      if (!Object.keys(updates).length && discountValue === null) return null;

      const payload = {
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname,
      };
      if (Object.keys(updates).length) payload.updates = updates;
      if (discountValue !== null) payload.discount = discountValue;

      return fetch(updateUrl, {
        ...fetchConfig(),
        body: JSON.stringify(payload),
      })
        .then((r) => r.json())
        .then((state) => {
          applyCartDrawerSectionState(state);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-drawer-sync', cartData: state });
          }
          return state;
        });
    })
    .catch(() => null);
}

function purgeOrphanChainUpgrades() {
  return syncCartDrawerSideEffects();
}

document.addEventListener('DOMContentLoaded', () => {
  syncCartDrawerSideEffects();
});

if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    if (event && (event.source === 'cart-drawer-sync' || event.source === 'chain-upgrade-purge')) return;
    syncCartDrawerSideEffects();
  });
}

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

if (!customElements.get('cart-drawer-items')) {
  customElements.define('cart-drawer-items', CartDrawerItems);
}
